import React, { useEffect, useState } from "react";
import "./App.css";
import rentme1 from "./rent-me-1.jpg";
import rentme2 from "./rent-me-2.jpg";
import rentme3 from "./rent-me-3.jpg";
import rentme4 from "./rent-me-4.jpg";
import rentme5 from "./rent-me-5.jpg";
import rentme6 from "./rent-me-6.jpg";
import rentme7 from "./rent-me-7.jpg";
import rentme8 from "./rent-me-8.jpg";
import rentme9 from "./rent-me-9.jpg";
import rentme10 from "./rent-me-10.jpg";
import rentme11 from "./rent-me-11.jpg";
// import rentme12 from "./rent-me12.png";

import vapemeuser1 from "./vape-me-user/1.png";
import vapemeuser2 from "./vape-me-user/2.png";
import vapemeuser3 from "./vape-me-user/3.png";
import vapemeuser4 from "./vape-me-user/4.png";
import vapemeuser5 from "./vape-me-user/5.png";
import vapemeuser6 from "./vape-me-user/6.png";
import vapemeuser7 from "./vape-me-user/7.png";
import vapemeuser8 from "./vape-me-user/8.png";
import vapemeuser9 from "./vape-me-user/9.png";
import vapemeuser10 from "./vape-me-user/10.png";
import vapemeuser11 from "./vape-me-user/11.png";

import vapemeadmin1 from "./vape-me-admin/1.png";
import vapemeadmin2 from "./vape-me-admin/2.png";
import vapemeadmin3 from "./vape-me-admin/3.png";
import vapemeadmin4 from "./vape-me-admin/4.png";
import vapemeadmin5 from "./vape-me-admin/5.png";
import vapemeadmin6 from "./vape-me-admin/6.png";
import vapemeadmin7 from "./vape-me-admin/7.png";
import vapemeadmin8 from "./vape-me-admin/8.png";
import vapemeadmin9 from "./vape-me-admin/9.png";
import vapemeadmin10 from "./vape-me-admin/10.png";

import mern from "./mern.png";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import pl from "./pl.png";
import uk from "./uk.png";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";

// Import modułów
import { Navigation } from "swiper/modules";
import { Pagination } from "swiper/modules";
import { Autoplay } from "swiper/modules";

const App = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  //Automatyczne zamykanie Mobile Menu gdy rozdzielczość wychodzi poza mobilną rozdzielczość
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 900) {
        setIsOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []); // Pusty tablica zależności, więc efekt uruchomi się tylko raz przy montowaniu komponentu

  //Mechanika smooth scrolla przy przechodzeniu między sekcjami
  useEffect(() => {
    const navLinks = document.querySelectorAll(".navbar a");

    navLinks.forEach((link) => {
      link.addEventListener("click", function (event) {
        event.preventDefault();

        const targetId = this.getAttribute("href").substring(1);

        const targetSection = document.getElementById(targetId);

        if (targetSection) {
          targetSection.scrollIntoView({ behavior: "smooth" });
        }
      });
    });
  }, []);

  const LanguageButton = ({ language, onClick }) => {
    return (
      <img
        onClick={toggleLanguage}
        className="language__btn"
        src={language === "polish" ? pl : uk}
        alt={language === "polish" ? "UK flag" : "PL flag"}
      />
    );
  };

  const LanguageButtonMobile = ({ language, onClick }) => {
    return (
      <img
        onClick={toggleLanguage}
        className="mobile_lang"
        src={language === "polish" ? pl : uk}
        alt={language === "polish" ? "UK flag" : "PL flag"}
      />
    );
  };
  const [language, setLanguage] = useState("english");

  const toggleLanguage = () => {
    setLanguage(language === "english" ? "polish" : "english");
  };

  return (
    <div id="start">
      <nav className="navbar">
        <h3 className="logo">Diamate.dev</h3>
        <LanguageButton language={language} onClick={toggleLanguage} />
        <ul className="nav-items">
          <li>
            <a href="#start">{language === "english" ? "Home" : "Start"}</a>
          </li>
          <li>
            <a href="#about">{language === "english" ? "About" : "O mnie"}</a>
          </li>
          <li>
            <a href="#projects">
              {language === "english" ? "Projects" : "Projekty"}
            </a>
          </li>
          <li>
            <a href="#contact">
              {language === "english" ? "Contact" : "Kontakt"}
            </a>
          </li>
        </ul>
        <div
          className={`mobile-menu ${isOpen ? "menu-open" : "menu-close"}`}
          onClick={toggleMenu}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="feather feather-menu"
          >
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </div>
      </nav>

      <div className={`mobile-nav ${isOpen ? "" : "closed-menu"}`}>
        <span className="tabler-icon" onClick={toggleMenu}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            {isOpen ? (
              <>
                <path d="M18 6l-12 12"></path>
                <path d="M6 6l12 12"></path>
              </>
            ) : (
              <path d="M3 12h18"></path>
            )}
          </svg>
        </span>

        <ul className="nav-items">
          <li className="mobile__lang">
            <LanguageButtonMobile
              language={language}
              onClick={toggleLanguage}
            />
          </li>
          <li>
            <a href="#start" onClick={closeMenu}>
              {language === "english" ? "Home" : "Start"}
            </a>
          </li>
          <li>
            <a href="#about" onClick={closeMenu}>
              {language === "english" ? "About" : "O mnie"}
            </a>
          </li>
          <li>
            <a href="#projects" onClick={closeMenu}>
              {language === "english" ? "Projects" : "Projekty"}
            </a>
          </li>
          <li>
            <a href="#contact" onClick={closeMenu}>
              {language === "english" ? "Contact" : "Kontakt"}
            </a>
          </li>
        </ul>
      </div>

      <div className="body">
        <section id="home" className="hero">
          <div className="container">
            <div className="content">
              <div className="hero-main">
                <div className="hero-text">
                  <h1>Front-End React Developer</h1>
                  <p>
                    {language === "english" ? (
                      <>
                        Hello there! I'm Jakub Grabski. A passionate Front-End
                        React/Next Developer, actually based in Częstochowa,
                        Poland.
                        <br />
                        <br />I thrive on developing interactive web
                        applications that not only captivate users with their
                        aesthetics but also deliver unforgettable user
                        experiences.
                      </>
                    ) : (
                      <>
                        Cześć! Nazywam się Jakub Grabski. Jestem front-end
                        developerem z prawie rocznym stażem specjalizującym się
                        w takich frameworkach jak React oraz Next. Aktualnie
                        mieszkam w Częstochowie.
                        <br /> <br /> W mojej pracy czerpię radość z tworzenia
                        interaktywnych aplikacji webowych, które nie tylko
                        zachwycą użytkowników swoją estetyką, ale także
                        przewyższą oczekiwania podczas korzystania z nich.
                      </>
                    )}
                  </p>
                  <span>
                    <a href="https://www.linkedin.com/in/jakub-grabski/">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="32"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="tabler-icon tabler-icon-brand-linkedin"
                      >
                        <path d="M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"></path>
                        <path d="M8 11l0 5"></path>
                        <path d="M8 8l0 .01"></path>
                        <path d="M12 16l0 -5"></path>
                        <path d="M16 16v-3a2 2 0 0 0 -4 0"></path>
                      </svg>
                    </a>
                    <a href="https://github.com/jakubGrabski67">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="32"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="tabler-icon tabler-icon-brand-github"
                      >
                        <path d="M9 19c-4.3 1.4 -4.3 -2.5 -6 -3m12 5v-3.5c0 -1 .1 -1.4 -.5 -2c2.8 -.3 5.5 -1.4 5.5 -6a4.6 4.6 0 0 0 -1.3 -3.2a4.2 4.2 0 0 0 -.1 -3.2s-1.1 -.3 -3.5 1.3a12.3 12.3 0 0 0 -6.2 0c-2.4 -1.6 -3.5 -1.3 -3.5 -1.3a4.2 4.2 0 0 0 -.1 3.2a4.6 4.6 0 0 0 -1.3 3.2c0 4.6 2.7 5.7 5.5 6c-.6 .6 -.6 1.2 -.5 2v3.5"></path>
                      </svg>
                    </a>
                  </span>
                </div>
                <div className="hero-img"></div>
              </div>
              <div className="skills">
                <p>
                  {language === "english"
                    ? "Current tech stack"
                    : "Obecny tech stack"}
                </p>
                <div className="logos">
                  <ul>
                    <li>
                      <img
                        style={{
                          marginRight: "10px",
                          width: "50px",
                          height: "50px",
                        }}
                        src="https://skillicons.dev/icons?i=html"
                        alt="skill-icon"
                      />
                      <img
                        style={{ width: "50px", height: "50px" }}
                        src="https://skillicons.dev/icons?i=css"
                        alt="skill-icon"
                      />
                    </li>

                    <li>
                      <img
                        style={{
                          marginRight: "10px",
                          width: "50px",
                          height: "50px",
                        }}
                        src="https://skillicons.dev/icons?i=js"
                        alt="skill-icon"
                      />
                      <img
                        style={{ width: "50px", height: "50px" }}
                        src="https://skillicons.dev/icons?i=ts"
                        alt="skill-icon"
                      />
                    </li>

                    <li>
                      <img
                        style={{
                          marginRight: "10px",
                          width: "50px",
                          height: "50px",
                        }}
                        src="https://skillicons.dev/icons?i=react"
                        alt="skill-icon"
                      />
                      <img
                        style={{ width: "50px", height: "50px" }}
                        src="https://skillicons.dev/icons?i=next"
                        alt="skill-icon"
                      />
                    </li>

                    <li>
                      <img
                        style={{
                          marginRight: "10px",
                          width: "50px",
                          height: "50px",
                        }}
                        src="https://skillicons.dev/icons?i=tailwind"
                        alt="skill-icon"
                      />
                      <img
                        style={{
                          marginRight: "10px",
                          width: "50px",
                          height: "50px",
                        }}
                        src="https://skillicons.dev/icons?i=materialui"
                        alt="skill-icon"
                      />
                      <img
                        style={{
                          marginRight: "10px",
                          width: "50px",
                          height: "50px",
                        }}
                        src="https://skillicons.dev/icons?i=styledcomponents"
                        alt="skill-icon"
                      />
                      <img
                        style={{
                          marginRight: "10px",
                          width: "50px",
                          height: "50px",
                        }}
                        src="https://skillicons.dev/icons?i=bootstrap"
                        alt="skill-icon"
                      />
                      <img
                        style={{ width: "50px", height: "50px" }}
                        src="https://skillicons.dev/icons?i=scss"
                        alt="skill-icon"
                      />
                    </li>

                    <li>
                      <img
                        style={{
                          marginRight: "10px",
                          width: "50px",
                          height: "50px",
                        }}
                        src="https://skillicons.dev/icons?i=express"
                        alt="skill-icon"
                      />
                      <img
                        style={{ width: "50px", height: "50px" }}
                        src="https://skillicons.dev/icons?i=redux"
                        alt="skill-icon"
                      />
                    </li>

                    <li>
                      <img
                        style={{
                          marginRight: "10px",
                          width: "50px",
                          height: "50px",
                        }}
                        src="https://skillicons.dev/icons?i=mongo"
                        alt="skill-icon"
                      />
                      <img
                        style={{
                          marginRight: "10px",
                          width: "50px",
                          height: "50px",
                        }}
                        src="https://skillicons.dev/icons?i=prisma"
                        alt="skill-icon"
                      />
                      <img
                        style={{ width: "50px", height: "50px" }}
                        src="https://skillicons.dev/icons?i=postgres"
                        alt="skill-icon"
                      />
                    </li>
                    <li>
                      <img
                        style={{
                          marginRight: "10px",
                          width: "50px",
                          height: "50px",
                        }}
                        src="https://skillicons.dev/icons?i=bitbucket"
                        alt="skill-icon"
                      />
                      <img
                        style={{
                          marginRight: "10px",
                          width: "50px",
                          height: "50px",
                        }}
                        src="https://skillicons.dev/icons?i=github"
                        alt="skill-icon"
                      />
                      <img
                        style={{ width: "50px", height: "50px" }}
                        src="https://skillicons.dev/icons?i=git"
                        alt="skill-icon"
                      />
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="about" className="about">
          <div className="container">
            <div className="about-content">
              <div className="img-side">
                <img className="img-side__main-img" src={mern} alt="" />
              </div>
              <div className="text-side">
                <h3>{language === "english" ? "About me" : "O mnie"}</h3>
                <h4>
                  {language === "english"
                    ? "Front-End Developer"
                    : "Front-end Developer"}
                  <br />
                  {language === "english"
                    ? "based in Częstochowa, Poland"
                    : "mieszkający w Częstochowie, Polska"}
                </h4>
                <p>
                  {language === "english" ? (
                    <>
                      Hey, my name is Jakub, and I'm a Frontend Developer. I
                      graduated as an engineer of IT at Opole University. My
                      main target is to create and develop interactive web
                      applications for my future users or customers. I love
                      paying attention to the smallest details. At this moment,
                      I currently have almost a year of commercial experience.
                    </>
                  ) : (
                    <>
                      Cześć, nazywam się Jakub i jestem Frontend developerem.
                      Ukończyłem studia jako inżynier informatyki na
                      Uniwersytecie Opolskim. Moim głównym celem jest tworzenie
                      i rozwijanie interaktywnych aplikacji internetowych dla
                      moich przyszłych użytkowników lub klientów. Uwielbiam
                      zwracać uwagę na najdrobniejsze szczegóły. Aktualnie
                      posiadam prawie rok doświadczenia komercyjnego.
                    </>
                  )}
                  <br />
                </p>
                <p>
                  {language === "english" ? (
                    <>
                      I'm mostly experienced in React or Next frameworks with
                      usage of JavaScript and TypeScript. I feel very familiar
                      working with Tailwind, StyledComponents, MaterialUI and
                      Bootstrap. I've been using version control such as github
                      or bitbucket since my first day of commercial experience.
                      Working with databases like MongoDB, PostgreSQL or Prisma
                      isn't a challenge for me. I took the Agile methodology
                      really personally.
                    </>
                  ) : (
                    <>
                      Największa część mojego doświadczenia to praca przy
                      frameworkach React lub Next z wykorzystaniem JavaScript i
                      TypeScript. Bardzo dobrze czuję się w pracy z Tailwind,
                      StyledComponents, MaterialUI i Bootstrap. Od początku
                      przygody z web development'em korzystam z kontroli wersji,
                      takiej jak github lub bitbucket. Praca z bazami danych,
                      takimi jak MongoDB, PostgreSQL lub Prisma, nie stanowi dla
                      mnie większego wyzwania. Podczas mojej pracy stanowczo
                      biorę metodologię Agile do serca.
                    </>
                  )}
                </p>
              </div>
            </div>
          </div>
        </section>

        <section id="projects" className="projects">
          <div className="container">
            <div className="projects__content">
              <div className="projects__title">
                <p>{language === "english" ? "Portfolio" : "Portfolio"}</p>
                <h3>
                  {language === "english"
                    ? "Here's a short description of my recent private projects"
                    : "Oto krótki opis moich ostatnich prywatnych projektów"}
                </h3>
              </div>

              <div className="container">
                <div className="projects-about-content">
                  <div className="text-side-projects">
                    <h3>Rent Me!</h3>

                    <p>
                      {language === "english" ? (
                        <>
                          Rent Me! is an online platform that is designed for
                          online car rental management. Users are able to rent
                          cars online for personal or business use. Employees
                          can easily manage the reservations, documentations and
                          active cars. The website provides an interface for
                          searching, comparing, and reserving cars. There is
                          also a possibility to pay online for the reservation
                          by using a Stripe Payments.
                        </>
                      ) : (
                        <>
                          Rent Me! to moja autorska aplikacja webowa
                          zaprojektowana do zarządzania wypożyczalnią samochodów
                          online. Klienci mogą rezerwowac oraz wynajmować
                          samochody online zarówno do celów osobistych, jak i
                          biznesowych. Pracownicy są w stanie łatwo zarządzać
                          rezerwacjami, dokumentacją, aktywnymi samochodami oraz
                          innymi ważnymi kwestiami podczas prowadzenia owej
                          działalności. Aplikacja zapewnia przyjazny dla
                          użytkownika interfejs do wybierania, porównywania i
                          rezerwowania samochodów. Dodatkowo w aplikacji
                          zaimplementowano możliwość dokonywania płatności
                          online za wypożyczenie pojazdu przy użyciu płatności
                          Stripe.
                        </>
                      )}
                    </p>

                    <p className="param__note">
                      {language === "english"
                        ? "NOTE: This project is made for desktop users only (1920 x 1080 px)"
                        : "UWAGA: Ten projekt jest dedykowany tylko na komputery stacjonarne (1920 x 1080 px)"}
                    </p>

                    <ul>
                      <li className="li-projects">
                        <a href="#here" onClick={(e) => e.preventDefault()}>
                          MongoDB
                        </a>
                      </li>

                      <li>
                        <a href="#here" onClick={(e) => e.preventDefault()}>
                          Express.js
                        </a>
                      </li>

                      <li>
                        <a href="#here" onClick={(e) => e.preventDefault()}>
                          React.js
                        </a>
                      </li>

                      <li>
                        <a href="#here" onClick={(e) => e.preventDefault()}>
                          Node.js
                        </a>
                      </li>
                    </ul>
                    <ul></ul>
                    <ul>
                      <li className="li-projects">
                        <a href="https://github.com/jakubGrabski67/rent-me">
                          {language === "english" ? "Code" : "Kod"}{" "}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            className="bi bi-github"
                            viewBox="0 0 16 16"
                            style={{ top: "3px", position: "relative" }}
                          >
                            <path d="M8 0C3.58 0 0 3.582 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0016 8c0-4.418-3.582-8-8-8z" />
                          </svg>
                        </a>
                      </li>

                      <li>
                        <a href="https://rent-me.onrender.com">
                          {language === "english" ? "Live demo" : "Wersja testowa"}{" "}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                            style={{ top: "4px", position: "relative" }}
                          >
                            <path
                              id="Vector"
                              d="M10.0002 5H8.2002C7.08009 5 6.51962 5 6.0918 5.21799C5.71547 5.40973 5.40973 5.71547 5.21799 6.0918C5 6.51962 5 7.08009 5 8.2002V15.8002C5 16.9203 5 17.4801 5.21799 17.9079C5.40973 18.2842 5.71547 18.5905 6.0918 18.7822C6.5192 19 7.07899 19 8.19691 19H15.8031C16.921 19 17.48 19 17.9074 18.7822C18.2837 18.5905 18.5905 18.2839 18.7822 17.9076C19 17.4802 19 16.921 19 15.8031V14M20 9V4M20 4H15M20 4L13 11"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="img-side-projects">
                    <Swiper
                      style={{ width: "100%" }}
                      spaceBetween={0}
                      slidesPerView={1}
                      navigation
                      pagination={{ clickable: true }}
                      autoplay={{ delay: 3000, disableOnInteraction: false }}
                      speed={1000}
                      modules={[Navigation, Pagination, Autoplay]}
                    >
                      <SwiperSlide>
                        <img
                          src={rentme1}
                          alt="Image 1"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </SwiperSlide>
                      <SwiperSlide>
                        <img
                          src={rentme2}
                          alt="Image 2"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </SwiperSlide>
                      <SwiperSlide>
                        <img
                          src={rentme3}
                          alt="Image 3"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </SwiperSlide>
                      <SwiperSlide>
                        <img
                          src={rentme4}
                          alt="Image 3"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </SwiperSlide>
                      <SwiperSlide>
                        <img
                          src={rentme5}
                          alt="Image 3"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </SwiperSlide>
                      <SwiperSlide>
                        <img
                          src={rentme6}
                          alt="Image 3"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </SwiperSlide>
                      <SwiperSlide>
                        <img
                          src={rentme7}
                          alt="Image 3"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </SwiperSlide>
                      <SwiperSlide>
                        <img
                          src={rentme8}
                          alt="Image 3"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </SwiperSlide>
                      <SwiperSlide>
                        <img
                          src={rentme9}
                          alt="Image 3"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </SwiperSlide>
                      <SwiperSlide>
                        <img
                          src={rentme10}
                          alt="Image 3"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </SwiperSlide>
                      <SwiperSlide>
                        <img
                          src={rentme11}
                          alt="Image 3"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </SwiperSlide>
                    </Swiper>
                  </div>
                </div>
              </div>
              <div style={{ marginTop: "5rem" }}></div>
              <div className="container">
                <div className="projects-about-content">
                  <div className="img-side-projects">
                    <Swiper
                      style={{ width: "100%" }}
                      spaceBetween={0}
                      slidesPerView={1}
                      navigation
                      pagination={{ clickable: true }}
                      autoplay={{ delay: 3000, disableOnInteraction: false }}
                      speed={1000}
                      modules={[Navigation, Pagination, Autoplay]}
                    >
                      <SwiperSlide>
                        <img
                          src={vapemeuser1}
                          alt="Image 1"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </SwiperSlide>
                      <SwiperSlide>
                        <img
                          src={vapemeuser2}
                          alt="Image 2"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </SwiperSlide>
                      <SwiperSlide>
                        <img
                          src={vapemeuser3}
                          alt="Image 3"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </SwiperSlide>
                      <SwiperSlide>
                        <img
                          src={vapemeuser4}
                          alt="Image 3"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </SwiperSlide>
                      <SwiperSlide>
                        <img
                          src={vapemeuser5}
                          alt="Image 3"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </SwiperSlide>
                      <SwiperSlide>
                        <img
                          src={vapemeuser6}
                          alt="Image 3"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </SwiperSlide>
                      <SwiperSlide>
                        <img
                          src={vapemeuser7}
                          alt="Image 3"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </SwiperSlide>
                      <SwiperSlide>
                        <img
                          src={vapemeuser8}
                          alt="Image 3"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </SwiperSlide>
                      <SwiperSlide>
                        <img
                          src={vapemeuser9}
                          alt="Image 3"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </SwiperSlide>
                      <SwiperSlide>
                        <img
                          src={vapemeuser10}
                          alt="Image 3"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </SwiperSlide>
                      <SwiperSlide>
                        <img
                          src={vapemeuser11}
                          alt="Image 3"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </SwiperSlide>
                    </Swiper>
                  </div>
                  <div
                    className="text-side-projects"
                    style={{ marginRight: "0px !imporant", marginLeft: "5rem" }}
                  >
                    <h3>Vape me - user side</h3>

                    <p>
                      {language === "english" ? (
                        <>
                          Vape-me! is an E-Commerce online store web application. The platform
                          offers customers a wide range of functionalities
                          such as easy and enjoyable online shopping. It has
                          plenty of functionalities, here's some of them: basket and observed products,
                          searching and sorting products, order history,
                          finalizing transactions, detailed product preview,
                          logging into the customer profile.
                        </>
                      ) : (
                        <>
                          Aplikacja webowa sklepu internetowego E-Commerce.
                          Platforma oferuje klientom szeroki zakres
                          funkcjonalności umożliwiających łatwe i przyjemne
                          zakupy online. Posiada takie funkcjonalności jak:
                          koszyk i obserwowane produkty, wyszukiwanie i
                          sortowanie produktów, historia zamówień, finalizacja
                          transakcji, szczegółowy podgląd produktu, logowanie do
                          profilu klienta.
                        </>
                      )}
                    </p>

                    <p className="param__notee">
                      {language === "english"
                        ? "This project is fully responsive."
                        : "Projekt jest w pełni responsywny."}
                    </p>

                    <ul>
                      <li className="li-projects">
                        <a href="#here" onClick={(e) => e.preventDefault()}>
                          HTML
                        </a>
                      </li>
                      <li className="li-projects">
                        <a href="#here" onClick={(e) => e.preventDefault()}>
                          JavaScript
                        </a>
                      </li>
                      <li className="li-projects">
                        <a href="#here" onClick={(e) => e.preventDefault()}>
                          Next.js
                        </a>
                      </li>

                      <li className="li-projects">
                        <a href="#here" onClick={(e) => e.preventDefault()}>
                          StyledComponents
                        </a>
                      </li>
                    </ul>
                    <ul>
                      <li className="li-projects">
                        <a href="#here" onClick={(e) => e.preventDefault()}>
                          Stripe
                        </a>
                      </li>

                      <li className="li-projects">
                        <a href="#here" onClick={(e) => e.preventDefault()}>
                          Axios
                        </a>
                      </li>
                      <li className="li-projects">
                        <a href="#here" onClick={(e) => e.preventDefault()}>
                          OAuth
                        </a>
                      </li>
                    </ul>
                    <ul>
                      <li className="li-projects">
                        <a href="https://github.com/jakubGrabski67/vape-me-frontend">
                          {language === "english" ? "Code" : "Kod"}{" "}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            className="bi bi-github"
                            viewBox="0 0 16 16"
                            style={{ top: "3px", position: "relative" }}
                          >
                            <path d="M8 0C3.58 0 0 3.582 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0016 8c0-4.418-3.582-8-8-8z" />
                          </svg>
                        </a>
                      </li>

                      <li>
                        <a href="https://vape-me.vercel.app">
                          {language === "english" ? "Live demo" : "Wersja testowa"}{" "}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                            style={{ top: "4px", position: "relative" }}
                          >
                            <path
                              id="Vector"
                              d="M10.0002 5H8.2002C7.08009 5 6.51962 5 6.0918 5.21799C5.71547 5.40973 5.40973 5.71547 5.21799 6.0918C5 6.51962 5 7.08009 5 8.2002V15.8002C5 16.9203 5 17.4801 5.21799 17.9079C5.40973 18.2842 5.71547 18.5905 6.0918 18.7822C6.5192 19 7.07899 19 8.19691 19H15.8031C16.921 19 17.48 19 17.9074 18.7822C18.2837 18.5905 18.5905 18.2839 18.7822 17.9076C19 17.4802 19 16.921 19 15.8031V14M20 9V4M20 4H15M20 4L13 11"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div style={{ marginTop: "5rem" }}></div>
              <div className="container">
                <div className="projects-about-content">
                  <div className="text-side-projects">
                    <h3>Vape Me - admin side</h3>

                    <p>
                      {language === "english" ? (
                        <>
                          Vape-Me! (admin) is a web application for managing an E-Commerce store. The
                          platform allows authenticated administrators to
                          effectively manage key aspects of the store. The main
                          functionalities are management of: products, order
                          handling, customers, payments, promotions, product
                          categorization, store home page.
                        </>
                      ) : (
                        <>
                          Aplikacja webowa do zarządzania sklepem E-Commerce.
                          Platforma umożliwia uwierzytelnionym administratorom
                          na efektywne zarządzanie kluczowymi aspektami sklepu.
                          Główne funkcjonalności to zarządzanie: produktami,
                          obsługą zamówień, klientami, płatnościami, promocjami,
                          kategoryzacją produktów, stroną główną sklepu.
                        </>
                      )}
                    </p>

                    <p className="param__notee">
                      {language === "english"
                        ? "This project is fully responsive."
                        : "Projekt jest w pełni responsywny."}
                    </p>

                    <ul>
                      <li className="li-projects">
                        <a href="#here" onClick={(e) => e.preventDefault()}>
                          HTML
                        </a>
                      </li>

                      <li>
                        <a href="#here" onClick={(e) => e.preventDefault()}>
                          JavaScript
                        </a>
                      </li>

                      <li>
                        <a href="#here" onClick={(e) => e.preventDefault()}>
                          Next.js
                        </a>
                      </li>

                      <li>
                        <a href="#here" onClick={(e) => e.preventDefault()}>
                          Tailwind
                        </a>
                      </li>
                    </ul>

                    <ul>
                      <li>
                        <a href="#here" onClick={(e) => e.preventDefault()}>
                          MongoDB
                        </a>
                      </li>
                      <li>
                        <a href="#here" onClick={(e) => e.preventDefault()}>
                          AWS
                        </a>
                      </li>
                      <li>
                        <a href="#here" onClick={(e) => e.preventDefault()}>
                          Axios
                        </a>
                      </li>
                      <li>
                        <a href="#here" onClick={(e) => e.preventDefault()}>
                          OAuth
                        </a>
                      </li>
                    </ul>
                    <ul>
                      <li className="li-projects">
                        <a href="https://github.com/jakubGrabski67/vape-me-admin">
                          {language === "english" ? "Code" : "Kod"}{" "}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            className="bi bi-github"
                            viewBox="0 0 16 16"
                            style={{ top: "3px", position: "relative" }}
                          >
                            <path d="M8 0C3.58 0 0 3.582 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0016 8c0-4.418-3.582-8-8-8z" />
                          </svg>
                        </a>
                      </li>

                      <li>
                        <a href="https://vape-me-admin.vercel.app">
                          {language === "english" ? "Live demo" : "Wersja testowa"}{" "}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                            style={{ top: "4px", position: "relative" }}
                          >
                            <path
                              id="Vector"
                              d="M10.0002 5H8.2002C7.08009 5 6.51962 5 6.0918 5.21799C5.71547 5.40973 5.40973 5.71547 5.21799 6.0918C5 6.51962 5 7.08009 5 8.2002V15.8002C5 16.9203 5 17.4801 5.21799 17.9079C5.40973 18.2842 5.71547 18.5905 6.0918 18.7822C6.5192 19 7.07899 19 8.19691 19H15.8031C16.921 19 17.48 19 17.9074 18.7822C18.2837 18.5905 18.5905 18.2839 18.7822 17.9076C19 17.4802 19 16.921 19 15.8031V14M20 9V4M20 4H15M20 4L13 11"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="img-side-projects">
                    <Swiper
                      style={{ width: "100%" }}
                      spaceBetween={0}
                      slidesPerView={1}
                      navigation
                      pagination={{ clickable: true }}
                      autoplay={{ delay: 3000, disableOnInteraction: false }}
                      speed={1000}
                      modules={[Navigation, Pagination, Autoplay]}
                    >
                      <SwiperSlide>
                        <img
                          src={vapemeadmin1}
                          alt="Image 1"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </SwiperSlide>
                      <SwiperSlide>
                        <img
                          src={vapemeadmin2}
                          alt="Image 2"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </SwiperSlide>
                      <SwiperSlide>
                        <img
                          src={vapemeadmin3}
                          alt="Image 3"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </SwiperSlide>
                      <SwiperSlide>
                        <img
                          src={vapemeadmin4}
                          alt="Image 3"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </SwiperSlide>
                      <SwiperSlide>
                        <img
                          src={vapemeadmin5}
                          alt="Image 3"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </SwiperSlide>
                      <SwiperSlide>
                        <img
                          src={vapemeadmin6}
                          alt="Image 3"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </SwiperSlide>
                      <SwiperSlide>
                        <img
                          src={vapemeadmin7}
                          alt="Image 3"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </SwiperSlide>
                      <SwiperSlide>
                        <img
                          src={vapemeadmin8}
                          alt="Image 3"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </SwiperSlide>
                      <SwiperSlide>
                        <img
                          src={vapemeadmin9}
                          alt="Image 3"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </SwiperSlide>
                      <SwiperSlide>
                        <img
                          src={vapemeadmin10}
                          alt="Image 3"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </SwiperSlide>
                    </Swiper>
                  </div>
                </div>
              </div>

              <div className="container">
                <h2 className="new-projects">
                  {language === "english"
                    ? "Something amazing is being built here"
                    : "Nowe projekty już wkrótce"}
                </h2>
              </div>
            </div>
          </div>
        </section>

        <section id="contact" className="contact">
          <div className="container">
            <div className="contact__content">
              <div className="contact__title">
                <p>{language === "english" ? "Contact" : "Kontakt"}</p>
                <h3>
                  {language === "english"
                    ? "You can find me there! 👇"
                    : "Skontaktujesz się ze mną poniżej! 👇"}
                </h3>
              </div>
              <div className="contact__icons">
                <div className="contact__icon-box">
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="30"
                      height="30"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="tabler-icon tabler-icon-map-search"
                    >
                      <path d="M11 18l-2 -1l-6 3v-13l6 -3l6 3l6 -3v7.5"></path>
                      <path d="M9 4v13"></path>
                      <path d="M15 7v5"></path>
                      <path d="M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"></path>
                      <path d="M20.2 20.2l1.8 1.8"></path>
                    </svg>
                  </span>
                  <div className="contact__info" style={{ marginTop: "-15px" }}>
                    <h3>
                      {language === "english" ? "Location" : "Lokalizacja"}
                    </h3>
                    <a href="/">
                      {language === "english"
                        ? "Częstochowa, Poland"
                        : "Częstochowa, Polska"}
                    </a>
                  </div>
                </div>
                <div className="contact__icon-box">
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="30"
                      height="30"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="tabler-icon tabler-icon-mail"
                    >
                      <path d="M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10z"></path>
                      <path d="M3 7l9 6l9 -6"></path>
                    </svg>
                  </span>
                  <div className="contact__info" style={{ marginTop: "-15px" }}>
                    <h3>{language === "english" ? "Mail" : "Poczta"}</h3>
                    <a href="mailto:kubagrabski22@gmail.com">
                      kubagrabski22@gmail.com
                    </a>
                  </div>
                </div>

                <div className="contact__icon-box">
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="30"
                      height="30"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="tabler-icon tabler-icon-mail"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" />
                      <path d="M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2" />
                    </svg>
                  </span>
                  <div className="contact__info" style={{ marginTop: "-15px" }}>
                    <h3>{language === "english" ? "Phone number" : "Telefon kontaktowy"}</h3>
                    <a href="tel:+48537533521">+48 537 533 521</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <h3>Copyright © 2024. All rights reserved.</h3>
            <div className="footer-content-socials">
              <a href="https://www.linkedin.com/in/jakub-grabski/">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="tabler-icon tabler-icon-brand-linkedin"
                >
                  <path d="M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"></path>
                  <path d="M8 11l0 5"></path>
                  <path d="M8 8l0 .01"></path>
                  <path d="M12 16l0 -5"></path>
                  <path d="M16 16v-3a2 2 0 0 0 -4 0"></path>
                </svg>
              </a>
              <a href="https://github.com/jakubGrabski67">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="tabler-icon tabler-icon-brand-github"
                >
                  <path d="M9 19c-4.3 1.4 -4.3 -2.5 -6 -3m12 5v-3.5c0 -1 .1 -1.4 -.5 -2c2.8 -.3 5.5 -1.4 5.5 -6a4.6 4.6 0 0 0 -1.3 -3.2a4.2 4.2 0 0 0 -.1 -3.2s-1.1 -.3 -3.5 1.3a12.3 12.3 0 0 0 -6.2 0c-2.4 -1.6 -3.5 -1.3 -3.5 -1.3a4.2 4.2 0 0 0 -.1 3.2a4.6 4.6 0 0 0 -1.3 3.2c0 4.6 2.7 5.7 5.5 6c-.6 .6 -.6 1.2 -.5 2v3.5"></path>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default App;
